import React, { useState } from "react";
import {
  Typography,
  Grid,
  TextField,
  Checkbox,
  Box,
  FormControlLabel,
  Button,
} from "@mui/material";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import Divider from "@mui/material/Divider";
import Chip from "@mui/material/Chip";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepContent from "@mui/material/StepContent";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { East } from "@mui/icons-material";

import CustomAppBar from "../../components/AppBar";

import { useTheme } from "@mui/material/styles";

import axios from "axios";

import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

import TransportSection from "./TransportSection";
import StorageSection from "./StorageSection";
import ProcessingSection from "./ProcessSection";
import PackagingSection from "./PackagingSection";

export default function FullModel() {
  const theme = useTheme();
  ChartJS.register(ArcElement, Tooltip, Legend);

  const styles = {
    icon: {
      marginRight: 2,
    },
    mainContent: {
      padding: 0.25,
      paddingLeft: 0.5,
      paddingRight: 0.5,
      flexGrow: 1,
    },
    row: {
      item: true,
      container: true,
      spacing: 1,
      justify: "center",
    },
    fab: {
      position: "fixed",
      bottom: 2,
      left: 2,
    },
    fabRow: {},
    fundSelectorRow: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
    },
    buttonRow: {
      margin: "10px",
      display: "flex",
      justifyContent: "space-around",
    },
    customheader: {
      textAlign: "center",
      [theme.breakpoints.up("md")]: {
        textAlign: "right",
      },
    },
  };
  const classes = styles;

  /* HARVEST */
  //  Crop information
  const [emissionFactors, setEmissionFactors] = useState({});
  const [cropName, setCropName] = useState("");
  const [type, setType] = useState("");

  /* HARVEST VARIABLES: These variables are used in the model*/

  //  Pre-harvest information
  const [isHerbicide, setIsHerbicide] = useState(false);
  const [isFungicide, setIsFungicide] = useState(false);
  const [isInsecticide, setIsInsecticide] = useState(false);
  const [isRodenticide, setIsRodenticide] = useState(false);

  const [isFAgriwaste, setIsFAgriwaste] = useState(false);
  const [isFManure, setIsFManure] = useState(false);
  const [isFNitrogen, setIsFNitrogen] = useState(false);
  const [isFPhosphorous, setIsFPhosphorous] = useState(false);
  const [isFPotassium, setIsFPotassium] = useState(false);

  /**Pesticide Calculation*/
  const [herbicide, setHerbicide] = useState(null);
  const [insecticide, setInsecticide] = useState(null);
  const [rodenticide, setRodenticide] = useState(null);
  const [fungicide, setFungicide] = useState(null);

  /**Fertilizer Calculation*/
  const [organic, setOrganic] = useState(null);
  const [manure, setManure] = useState(null);
  const [nitrogenBased, setNitrogenBased] = useState(null);
  const [phosphorousBased, setPhosphorousBased] = useState(null);
  const [potassiumBased, setPotassiumBased] = useState(null);

  const [irrigationType, setIrrigationType] = useState("");
  const [irrigationEmission, setIrrigationEmission] = useState(null);
  const [isCalcTotal, setIsCalcTotal] = useState(false);

  //  Post Harvest Information
  const [harvestElectricity, setHarvestElectricity] = useState(null);
  const [harvestFuelType, setHarvestFuelType] = useState("");
  const [harvestFuel, setHarvestFuel] = useState(null);

  const [farmSize, setFarmSize] = useState(null);
  const [harvest, setHarvest] = useState(null);
  const [totalHarvestEmission, setTotalHarvestEmission] = useState(null);

  /**TRANSPORT */

  const [totalTransportEmission, setTotalTransportEmission] = useState([]);

  /**STORAGE */
  const [totalStorageEmission, setTotalStorageEmission] = useState([]);

  /**Processing */

  const [totalProcessEmission, setTotalProcessEmission] = useState(null);

  /**Packaging */
  const [totalPackagingEmission, setTotalPackagingEmission] = useState(null);

  /**FINAL CALC */
  const [totalCarbonEmission, setTotalCarbonEmission] = useState(0);

  const graphData = [];

  const data = {
    labels: ["Harvest", "Transport", "Storage", "Process", "Packaging"],
    datasets: [
      {
        data: graphData,
        backgroundColor: [
          "#FF6384",
          "#36A2EB",
          "#FFCE56",
          "#4BC0C0",
          "#FF0000",
        ],
      },
    ],
  };
  const options = {
    plugins: {
      legend: {
        display: true,
        position: "bottom",
      },
    },
  };

  const steps = ["Harvest", "Transport", "Storage", "Processing", "Packaging"];

  const calculation = () => {
    let calculatedTransportEmission = 0;
    let calculatedStorageEmission = 0;

    if (totalTransportEmission !== null) {
      calculatedTransportEmission = totalTransportEmission
        .map((entry) => entry.emission)
        .reduce((acc, current) => acc + current, 0);
    }

    if (totalStorageEmission !== null) {
      calculatedStorageEmission = totalStorageEmission
        .map((entry) => entry.emission)
        .reduce((acc, current) => acc + current, 0);
    }

    const pesticideResult =
      emissionFactors.Pre_Harvest.Pesticides.Herbicide * herbicide +
      emissionFactors.Pre_Harvest.Pesticides.Insecticide * insecticide +
      emissionFactors.Pre_Harvest.Pesticides.Rodenticide * rodenticide +
      emissionFactors.Pre_Harvest.Pesticides.Fungicide * fungicide;
    const fertilizerResult =
      emissionFactors.Pre_Harvest.Fertilizers.Organic * organic +
      emissionFactors.Pre_Harvest.Fertilizers.Manure * manure +
      emissionFactors.Pre_Harvest.Fertilizers.Nitrogen_based * nitrogenBased +
      emissionFactors.Pre_Harvest.Fertilizers.Phosphorous_based *
        phosphorousBased;

    let newpPesticideResult = pesticideResult;
    let newFertilizerResult = fertilizerResult;

    if (isCalcTotal == false) {
      newpPesticideResult = pesticideResult * farmSize;
      newFertilizerResult = fertilizerResult * farmSize;
    }

    console.log("Pesticide Sum: ", newpPesticideResult);
    console.log("Fertilizer Sum: ", newFertilizerResult);

    const irrigationResult =
      emissionFactors.Pre_Harvest.Irrigation[irrigationType] * farmSize;
    setIrrigationEmission(irrigationResult);
    console.log("Pesticide Sum: ", irrigationResult);

    const hElecResult =
      emissionFactors.Post_Harvest.Electricity_used * harvestElectricity;
    console.log("Harvest Electricity : ", hElecResult);
    const hFuelResult =
      emissionFactors.Post_Harvest.Fuel_used[harvestFuelType] * harvestFuel;
    console.log("Fuel : ", hFuelResult);

    const harvestEmission =
      pesticideResult +
      fertilizerResult +
      irrigationResult +
      hElecResult +
      hFuelResult;
    setTotalHarvestEmission(harvestEmission);
    graphData[0] = totalHarvestEmission;
    console.log("Total Harvest : ", totalHarvestEmission);

    // graphData[1]=totalTransportEmission
    graphData[1] = calculatedTransportEmission;
    console.log("Total Transport : ", calculatedTransportEmission);

    // graphData[2]=totalStorageEmission
    graphData[2] = calculatedStorageEmission;
    console.log("Total Storage : ", calculatedStorageEmission);

    graphData[3] = totalProcessEmission;
    console.log("Total Process : ", totalProcessEmission);

    // const packageResult =  (emissionFactors.Process.Electricity_used * packageElectricity)
    // setTotalPackagingEmission(packageResult);
    graphData[4] = totalPackagingEmission;
    console.log("Total Packaging : ", totalPackagingEmission);

    const total =
      totalHarvestEmission +
      calculatedStorageEmission +
      calculatedTransportEmission +
      totalProcessEmission +
      totalPackagingEmission;
    setTotalCarbonEmission(total);
    console.log(graphData);
    console.log("Total", totalCarbonEmission);
  };

  console.log(irrigationEmission);

  const handleChange = async (event) => {
    const { value } = event.target;
    setCropName(value);

    try {
      const response = await axios.post(
        "http://localhost:8000/emission-factors/get-emission-factors/",
        { vegetable_name: value }
      );
      const data = response.data;
      console.log(data);
      // Handle the response data
      //   console.log([value]);
      setEmissionFactors(data);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const [activeStep, setActiveStep] = React.useState(0);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    calculation();
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const handleStepClick = (stepIndex) => {
    setActiveStep(stepIndex);
  };

  return (
    <>
      <CustomAppBar />

      <Grid container fullWidth mx="auto" justifyContent="center">
        <Grid
          xs={3}
          mt="12%"
          sx={{
            display: { xs: "none", sm: "none", md: "flex", lg: "flex" },
          }}
        >
          <Box ml="20%" sx={{ maxWidth: 400 }}>
            <Stepper activeStep={activeStep} orientation="vertical">
              {steps.map((label, index) => (
                <Step key={label}>
                  <StepLabel
                    onClick={() => handleStepClick(index)}
                    style={{ cursor: "pointer" }}
                  >
                    <Typography
                      variant={activeStep === index ? "h4" : "h4"}
                      color={activeStep === index ? "primary" : "textPrimary"}
                      fontWeight={activeStep === index ? 600 : 400}
                    >
                      {label}
                    </Typography>
                  </StepLabel>
                  <StepContent>
                    <Box sx={{ mb: 2 }}>
                      <Button
                        variant="contained"
                        onClick={handleNext}
                        sx={{ mt: 1, mr: 1 }}
                      >
                        Continue
                      </Button>
                      {activeStep !== 0 && (
                        <Button onClick={handleBack} sx={{ mt: 1, mr: 1 }}>
                          Back
                        </Button>
                      )}
                    </Box>
                  </StepContent>
                </Step>
              ))}
            </Stepper>
            {activeStep === steps.length && (
              <Paper mx="auto" square elevation={0} sx={{ p: 3 }}>
                <Typography>All steps completed</Typography>
                <Box mx="auto">
                  <Button
                    onClick={handleReset}
                    variant="outlined"
                    sx={{ mt: 2 }}
                  >
                    Reset
                  </Button>
                </Box>
              </Paper>
            )}
          </Box>
        </Grid>

        <Grid
          xs={12}
          mt={4}
          px={1}
          sx={{
            display: { xs: "flex", sm: "flex", md: "none", lg: "none" },
          }}
        >
          <Stepper activeStep={activeStep}>
            {steps.map((label, index) => (
              <Step
                key={label}
                onClick={() => handleStepClick(index)}
                style={{ cursor: "pointer" }}
              >
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </Grid>

        <Grid xs={11} md={8}>
          {/* Harvest section */}
          {activeStep === 0 && (
            <Grid
              style={{
                boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px",
                background:
                  "linear-gradient(to right bottom, #ffffff, #fdfdfe, #fafbfd, #f7f9fb, #f3f7fa",
              }}
              borderRadius={4}
              container
              fullWidth
              justifyContent="center"
              p={3}
              mx="auto"
              my="10%"
              xs={12}
            >
              <Grid item xs={12} flex>
                <Typography
                  className={classes.customheader}
                  ml={2}
                  mb={4}
                  variant="h4"
                >
                  Harvest
                </Typography>
                <Box fullWidth my={2}>
                  <Divider my={2} textAlign="left">
                    <Chip
                      sx={{ fontSize: "1rem", fontWeight: "600" }}
                      color="primary"
                      label="Pre harvest information"
                    />
                  </Divider>
                </Box>
              </Grid>

              <Grid container xs={12} flex fullWidth>
                <Grid item xs={12} md={6} py={2} px={4}>
                  <Typography variant="h6">Select crop type</Typography>
                  <Box mt={2}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        Crop type
                      </InputLabel>
                      <Select
                        required
                        labelId="demo-simple-select-label"
                        value={type}
                        label="Crop type"
                        onChange={(e) => {
                          setType(e.target.value);
                        }}
                      >
                        <MenuItem value={"Rabi"}>Rabi</MenuItem>
                        <MenuItem value={"Kharif"}>Kharif</MenuItem>
                        <MenuItem value={"Zaid"}>Zaid</MenuItem>
                      </Select>
                    </FormControl>
                  </Box>
                </Grid>
                <Grid item xs={12} md={6} py={2} px={4}>
                  <Typography variant="h6">Select crop name</Typography>
                  <Box mt={2}>
                    <FormControl fullWidth>
                      <InputLabel id="select-crop-name">Crop Name</InputLabel>
                      <Select
                        required
                        labelId="select-crop-name"
                        value={cropName}
                        onChange={handleChange}
                        label="Crop Name"
                        // onChange={(e) => {
                        //     setCropName(e.target.value);
                        // }}
                      >
                        <MenuItem value={"Potato"}>Potato</MenuItem>
                        <MenuItem value={"Grapes"}>Grapes</MenuItem>
                        <MenuItem value={"Tomato"}>Tomato</MenuItem>
                        <MenuItem value={"Rice"}>Rice</MenuItem>
                        <MenuItem value={"PalmOil"}>Palm Oil</MenuItem>
                      </Select>
                    </FormControl>
                  </Box>
                </Grid>
              </Grid>

              <Grid container xs={12} flex fullWidth>
                <Grid item xs={12} md={6} py={2} px={4}>
                  <Typography variant="h6">Select irrigation type</Typography>
                  <Box mt={2}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        Irrigation type
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        value={irrigationType}
                        label="Irrigation type"
                        onChange={(e) => {
                          setIrrigationType(e.target.value);
                        }}
                      >
                        <MenuItem value={"Sprinkler"}>Sprinkler</MenuItem>
                        <MenuItem value={"Drip"}>Drip</MenuItem>
                        <MenuItem value={"Surface"}>Surface</MenuItem>
                      </Select>
                    </FormControl>
                  </Box>
                </Grid>
              </Grid>

              <Grid container xs={12} flex fullWidth>
                <Grid item xs={12} md={6} py={2} px={4}>
                  <Typography variant="h6">Select Pesticides Used</Typography>

                  <Box flex mt={2}>
                    <TextField
                      value={herbicide}
                      label={isCalcTotal ? "total kg used" : "kg used per acre"}
                      variant="outlined"
                      onChange={(e) => {
                        setHerbicide(e.target.value);
                      }}
                    />

                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={isHerbicide}
                          onChange={(event) =>
                            setIsHerbicide(event.target.checked)
                          }
                        />
                      }
                      label="Herbicide"
                    />
                    {isHerbicide && (
                      <TextField
                        value={herbicide}
                        label={
                          isCalcTotal ? "total kg used" : "kg used per acre"
                        }
                        variant="outlined"
                        onChange={(e) => {
                          setHerbicide(e.target.value);
                        }}
                      />
                    )}
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={isInsecticide}
                          onChange={(event) =>
                            setIsInsecticide(event.target.checked)
                          }
                        />
                      }
                      label="Insecticide"
                    />
                    {isInsecticide && (
                      <TextField
                        value={insecticide}
                        label={
                          isCalcTotal ? "total kg used" : "kg used per acre"
                        }
                        variant="outlined"
                        onChange={(e) => {
                          setInsecticide(e.target.value);
                        }}
                      />
                    )}
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={isRodenticide}
                          onChange={(event) =>
                            setIsRodenticide(event.target.checked)
                          }
                        />
                      }
                      label="Rodenticide"
                    />
                    {isRodenticide && (
                      <TextField
                        value={rodenticide}
                        label={
                          isCalcTotal ? "total kg used" : "kg used per acre"
                        }
                        variant="outlined"
                        onChange={(e) => {
                          setRodenticide(e.target.value);
                        }}
                      />
                    )}
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={isFungicide}
                          onChange={(event) =>
                            setIsFungicide(event.target.checked)
                          }
                        />
                      }
                      label="Fungicide"
                    />
                    {isFungicide && (
                      <TextField
                        value={fungicide}
                        label={
                          isCalcTotal ? "total kg used" : "kg used per acre"
                        }
                        variant="outlined"
                        onChange={(e) => {
                          setFungicide(e.target.value);
                        }}
                      />
                    )}
                  </Box>
                </Grid>
              </Grid>

              <Grid container xs={12} flex fullWidth>
                <Grid item xs={12} md={6} py={2} px={4}>
                  <Typography variant="h6">Select Fertilizers Used</Typography>
                  <Box flex mt={2}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          sx={{ my: 1 }}
                          checked={isFAgriwaste}
                          onChange={(event) =>
                            setIsFAgriwaste(event.target.checked)
                          }
                        />
                      }
                      label="Organic"
                    />
                    {isFAgriwaste && (
                      <TextField
                        sx={{ my: 1 }}
                        value={organic}
                        label={
                          isCalcTotal ? "total kg used" : "kg used per acre"
                        }
                        variant="outlined"
                        onChange={(e) => {
                          setOrganic(e.target.value);
                        }}
                      />
                    )}
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          sx={{ my: 1 }}
                          checked={isFManure}
                          onChange={(event) =>
                            setIsFManure(event.target.checked)
                          }
                        />
                      }
                      label="Manure"
                    />
                    {isFManure && (
                      <TextField
                        sx={{ my: 1 }}
                        value={manure}
                        label={
                          isCalcTotal ? "total kg used" : "kg used per acre"
                        }
                        variant="outlined"
                        onChange={(e) => {
                          setManure(e.target.value);
                        }}
                      />
                    )}
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          sx={{ my: 1 }}
                          checked={isFNitrogen}
                          onChange={(event) =>
                            setIsFNitrogen(event.target.checked)
                          }
                        />
                      }
                      label="Nitrogen based"
                    />
                    {isFNitrogen && (
                      <TextField
                        sx={{ my: 1 }}
                        value={nitrogenBased}
                        label={
                          isCalcTotal ? "total kg used" : "kg used per acre"
                        }
                        variant="outlined"
                        onChange={(e) => {
                          setNitrogenBased(e.target.value);
                        }}
                      />
                    )}
                    <br />
                  </Box>
                </Grid>
                <Grid item xs={12} md={6} py={2} px={4}>
                  <Box flex sx={{ mt: { xs: 1, sm: 1, md: 6 } }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          sx={{ my: 1 }}
                          checked={isFPhosphorous}
                          onChange={(event) =>
                            setIsFPhosphorous(event.target.checked)
                          }
                        />
                      }
                      label="Phosphorous based"
                    />
                    {isFPhosphorous && (
                      <TextField
                        sx={{ my: 1 }}
                        value={phosphorousBased}
                        label={
                          isCalcTotal ? "total kg used" : "kg used per acre"
                        }
                        variant="outlined"
                        onChange={(e) => {
                          setPhosphorousBased(e.target.value);
                        }}
                      />
                    )}
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          sx={{ my: 1 }}
                          checked={isFPotassium}
                          onChange={(event) =>
                            setIsFPotassium(event.target.checked)
                          }
                        />
                      }
                      label="Potassium based"
                    />
                    {isFPotassium && (
                      <TextField
                        sx={{ my: 1 }}
                        value={potassiumBased}
                        label={
                          isCalcTotal ? "Total kg Used" : "kg used Per Acre"
                        }
                        variant="outlined"
                        onChange={(e) => {
                          setPotassiumBased(e.target.value);
                        }}
                      />
                    )}
                  </Box>
                </Grid>
                <Grid item flex xs={12} py={2} px={4}>
                  {isCalcTotal ? (
                    <Typography
                      variant="body1"
                      style={{ fontStyle: "italic", fontSize: 16 }}
                    >
                      Calculating Data for Total Farm,{" "}
                      <Button
                        onClick={() =>
                          setIsCalcTotal((prevState) => !prevState)
                        }
                        variant="text"
                        color="primary"
                      >
                        click here
                      </Button>{" "}
                      to Calculate using Per Acre Consumed
                    </Typography>
                  ) : (
                    <Typography
                      variant="body1"
                      style={{ fontStyle: "italic", fontSize: 16 }}
                    >
                      Calculating Data Per Acre,{" "}
                      <Button
                        onClick={() =>
                          setIsCalcTotal((prevState) => !prevState)
                        }
                        variant="text"
                        color="primary"
                      >
                        click here
                      </Button>{" "}
                      to Calculate using Total Consumed for Farm.
                    </Typography>
                  )}
                </Grid>
              </Grid>

              <Grid my={2} item xs={12} flex>
                <Divider textAlign="left">
                  <Chip
                    sx={{ fontSize: "1rem", fontWeight: "600" }}
                    color="primary"
                    label="Post harvest information"
                  />
                </Divider>
              </Grid>

              <Grid container xs={12} flex fullWidth>
                <Grid item flex xs={12} md={4} py={2} px={4}>
                  <Typography variant="h6">Electricty used</Typography>

                  <Box fullWidth flex mt={2}>
                    <TextField
                      fullWidth
                      label="in kWh"
                      variant="outlined"
                      value={harvestElectricity}
                      onChange={(event) =>
                        setHarvestElectricity(event.target.value)
                      }
                    />
                  </Box>
                </Grid>
                <Grid item flex xs={12} md={4} py={2} px={4}>
                  <Typography variant="h6">Fuel type</Typography>

                  <Box mt={2}>
                    <FormControl fullWidth>
                      <InputLabel id="select-crop-name">Fuel type</InputLabel>
                      <Select
                        labelId="select-crop-name"
                        value={harvestFuelType}
                        label="Fuel type"
                        onChange={(e) => {
                          setHarvestFuelType(e.target.value);
                        }}
                      >
                        <MenuItem value={"Diesel"}>Diesel</MenuItem>
                        <MenuItem value={"Petrol"}>Petrol</MenuItem>
                        <MenuItem value={"Kerosene"}>Kerosene</MenuItem>
                        <MenuItem value={"Biogas"}>Bio Gas</MenuItem>
                      </Select>
                    </FormControl>
                  </Box>
                </Grid>
                <Grid item flex xs={12} md={4} py={2} px={4}>
                  <Typography variant="h6">Fuel used</Typography>

                  <Box flex mt={2}>
                    <TextField
                      fullWidth
                      label="in litres"
                      variant="outlined"
                      value={harvestFuel}
                      onChange={(event) => setHarvestFuel(event.target.value)}
                    />
                  </Box>
                </Grid>
                <Grid item flex xs={12} md={4} py={2} px={4}>
                  <Typography variant="h6">Yield obtained</Typography>

                  <Box flex mt={2}>
                    <TextField
                      fullWidth
                      label="in kgs"
                      variant="outlined"
                      value={harvest}
                      onChange={(event) =>
                        setHarvest(parseFloat(event.target.value))
                      }
                    />
                  </Box>
                </Grid>
                <Grid item flex xs={12} md={4} py={2} px={4}>
                  <Typography variant="h6">Farm size</Typography>

                  <Box flex mt={2}>
                    <TextField
                      fullWidth
                      label="in acres"
                      variant="outlined"
                      value={farmSize}
                      onChange={(event) =>
                        setFarmSize(parseFloat(event.target.value))
                      }
                    />
                  </Box>
                </Grid>

                <Grid
                  item
                  flex
                  xs={6}
                  ml="40%"
                  py={2}
                  px={4}
                  sx={{
                    display: {
                      xs: "block",
                      sm: "block",
                      md: "block",
                      lg: "block",
                    },
                  }}
                >
                  <Box mx="auto">
                    <Button
                      variant="contained"
                      onClick={handleNext}
                      endIcon={<East />}
                      sx={{ mt: 1, ml: 2, width: "10rem" }}
                    >
                      Next Section
                    </Button>
                  </Box>
                </Grid>
                {/*
                     <Grid item flex xs={12} md={4} py={2} px={4}>
                         <Typography variant='h6'>
                             Total harvest obtained
                         </Typography>
 
                         <Box flex mt={2}>
                             <TextField
                                 fullWidth
                                 label="in kgs"
                                 variant="outlined"
                                 value={harvest}
                                 // onChange={(event) => setElectricityUsed(event.target.value)}
                             />
                         </Box>
                     </Grid>
                     */}
              </Grid>
            </Grid>
          )}

          {/* Transporation section */}
          {activeStep === 1 && (
            <TransportSection
              totalTransportEmission={totalTransportEmission}
              handleNext={handleNext}
              handleBack={handleBack}
              harvest={harvest}
              emissionFactors={emissionFactors}
              setTotalTransportEmission={setTotalTransportEmission}
            />
          )}

          {/* Storage section */}
          {activeStep === 2 && (
            <StorageSection
              totalStorageEmission={totalStorageEmission}
              handleNext={handleNext}
              handleBack={handleBack}
              emissionFactors={emissionFactors}
              setTotalStorageEmission={setTotalStorageEmission}
            />
          )}

          {/* Process section */}
          {activeStep === 3 && (
            <ProcessingSection
              cropName={cropName}
              harvest={harvest}
              totalProcessEmission={totalProcessEmission}
              handleNext={handleNext}
              handleBack={handleBack}
              emissionFactors={emissionFactors}
              setTotalProcessEmission={setTotalProcessEmission}
            />
          )}

          {/* Packaging section */}
          {activeStep === 4 && (
            <PackagingSection
              harvest={harvest}
              totalPackagingEmission={totalPackagingEmission}
              handleNext={handleNext}
              handleBack={handleBack}
              emissionFactors={emissionFactors}
              setTotalPackagingEmission={setTotalPackagingEmission}
            />
          )}

          {/* Total Carbon Emission */}
          {activeStep === 5 && (
            <Grid
              container
              fullWidth
              justifyContent="center"
              mx="auto"
              my="20%"
              borderRadius={4}
              p={3}
              xs={12}
              style={{
                boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px",
                background:
                  "linear-gradient(to right bottom, #ffffff, #fdfdfe, #fafbfd, #f7f9fb, #f3f7fa",
              }}
            >
              <Grid item xs={12} flex>
                <Typography
                  className={classes.customheader}
                  mb={3}
                  pl={4}
                  pt={4}
                  variant="h4"
                >
                  Total Carbon emission
                </Typography>
              </Grid>

              <Grid container xs={8} mx="auto" flex fullWidth py={2} px={4}>
                <Grid item flex mt={2} mb={2} xs={12} md={10} mx="auto">
                  <Typography textAlign="center" variant="h6">
                    Carbon emission
                  </Typography>
                  <Typography textAlign="center" color="primary" variant="h5">
                    {totalCarbonEmission.toFixed(3)} kg CO2 eq
                  </Typography>
                  {/* 
                        <Grid item sx={{ mx:"auto"}} flex mx="auto">
                            <Button mx="auto" variant='contained' onClick={calculation}>Calculate</Button>
                        </Grid>
                        */}
                </Grid>

                <Grid my={2} xs={12} md={8} mx="auto">
                  <Doughnut data={data} options={options} />
                </Grid>
              </Grid>
              <Grid my={3} xs={12} md={8} mx="auto">
                <TableContainer sx={{ borderRadius: 4 }} component={Paper}>
                  <Table sx={{ minWidth: "100%" }}>
                    <TableHead>
                      <TableRow>
                        <TableCell align="left">
                          <Typography fontWeight="bold" variant="h6">
                            Stage
                          </Typography>
                        </TableCell>
                        <TableCell align="center">
                          <Typography fontWeight="bold" variant="h6">
                            Carbon Emission <br /> ( in kg CO2 eq )
                          </Typography>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell align="left">
                          <Typography variatn="h6">Harvestation</Typography>
                        </TableCell>
                        <TableCell align="center">
                          <Chip
                            label={
                              <Typography variant="body1" fontWeight="bold">
                                {graphData[0].toFixed(3)}
                              </Typography>
                            }
                          />
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell align="left">
                          <Typography variatn="h6">Transporation</Typography>
                        </TableCell>
                        <TableCell align="center">
                          <Chip
                            label={
                              <Typography variant="body1" fontWeight="bold">
                                {graphData[1].toFixed(3)}
                              </Typography>
                            }
                          />
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell align="left">
                          <Typography variatn="h6">Storage</Typography>
                        </TableCell>
                        <TableCell align="center">
                          <Chip
                            label={
                              <Typography variant="body1" fontWeight="bold">
                                {graphData[2].toFixed(3)}
                              </Typography>
                            }
                          />
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell align="left">
                          <Typography variatn="h6">Processing</Typography>
                        </TableCell>
                        <TableCell align="center">
                          <Chip
                            label={
                              <Typography variant="body1" fontWeight="bold">
                                {graphData[3].toFixed(3)}
                              </Typography>
                            }
                          />
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell align="left">
                          <Typography variatn="h6">Packaging</Typography>
                        </TableCell>
                        <TableCell align="center">
                          <Chip
                            label={
                              <Typography variant="body1" fontWeight="bold">
                                {graphData[4].toFixed(3)}
                              </Typography>
                            }
                          />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>
    </>
  );
}
